import React, { useState } from "react";
import Link from "next/link";
import AuthLayout, {
  authButtonClass,
  authFieldClass,
} from "@/components/AuthLayout";

export default function ForgotPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      await fetch("/api/auth/forgot", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
    } finally {
      // Uniform outcome regardless of whether the account exists.
      setBusy(false);
      setSent(true);
    }
  };

  return (
    <AuthLayout title="Reset password">
      <h2 className="text-2xl font-bold tracking-tight text-slate-900">
        Forgot your password?
      </h2>
      <p className="mt-1.5 text-[14px] text-slate-500">
        Enter your email and we&apos;ll send a reset link.
      </p>

      {sent ? (
        <div className="mt-8 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-[13px] leading-relaxed text-emerald-700">
          If that email has an account, a reset link is on its way. It works
          once and expires in 1 hour — check spam if it doesn&apos;t arrive.
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="mb-1.5 block text-[13px] font-medium text-slate-700">
              Email
            </label>
            <input
              type="email"
              required
              autoFocus
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              className={authFieldClass}
            />
          </div>
          <button type="submit" disabled={busy} className={authButtonClass}>
            {busy ? "Sending..." : "Send reset link"}
          </button>
        </form>
      )}

      <p className="mt-6 text-center text-[13px] text-slate-500">
        Remembered it?{" "}
        <Link
          href="/login"
          className="font-semibold text-indigo-600 hover:text-indigo-700"
        >
          Sign in
        </Link>
      </p>
    </AuthLayout>
  );
}
